// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"255f0d51","389":"bc63765c","455":"bf038528","977":"35d69cb2"}[chunkId] + ".chunk.js";
};